<template>

  <div class="github-card">
    <div class="github-number">{{String(number).padStart(3,'0')}}</div>
    <div class="light-pad">
      <font-awesome-icon :icon="['fab', 'github']" class="social-icon"/>
      <a :href="uri" target="_blank" >{{name}}</a>
    </div>
    <div class="github-img">
      <div v-if="!url" class="gradient-fill" :style="generate"></div>
      <img :src="url" alt>
    </div>
  </div>
</template>
<script>
export default {
  name: "GithubProjectCard",
  props: {
    name: String,
    number: Number,
    url: String,
    uri:String
  },
  computed: {
    generate: function() {
      var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e"
      ];

      function populate(a) {
        for (var i = 0; i < 6; i++) {
          var x = Math.round(Math.random() * 14);
          var y = hexValues[x];
          a += y;
        }
        return a;
      }

      var newColor1 = populate("#");
      var newColor2 = populate("#");
      var angle = Math.round(Math.random() * 360);

      var gradient =
        "background: linear-gradient(" +
        angle +
        "deg, " +
        newColor1 +
        ", " +
        newColor2 +
        ")";
      return gradient;
    }
  }
};
</script>
<style lang="scss" scoped >

.github-card:hover {
  box-shadow: 0 8px 36px 0 rgba(10, 16, 34, 0.25), 0 0 0 transparent;
  transform: translateY(-6px) translateZ(0px);
}
img {
  height: 200px;
  max-width: 350px;
  overflow: hidden;
  flex-shrink: 0;
}
.gradient-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.github-img {
  display: flex;
  height: 200px;
  width: 350px;
  -webkit-clip-path: polygon(50% 0%, 100% 0, 100% 100%, 0 100%, 0 0);
  clip-path: polygon(50% 0%, 100% 0, 100% 100%, 0 100%, 0 0);
  justify-content: center;
  position: relative;
  align-items: center;
  overflow: hidden;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
.github-img:hover {
    animation: polygons 2s alternate infinite;
}
.github-number {
  position: absolute;
  font-weight: 700;
  font-size: 4rem;
  right: -50px;
  top: -40px;
  color: rgba(159, 159, 159, 0.205);
}
.github-card {
  position: relative;
  width: fit-content;
  height: fit-content;
  max-height: 250px;
  display: flex;
  flex-direction: column;
    box-shadow: 0 1px 20px 1px rgba(10, 16, 34, 0.08);
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out,
    -webkit-transform 0.3s ease-out, -webkit-box-shadow 0.3s ease-out;
  border-radius: 12px;
  a {
    text-decoration: none;
    padding-left:0.5rem; 
  }
}

@media screen and (max-width: 720px) {
 .github-img,img {
   width: 70vw;
  
 }
 .github-number  {
   display: none;
 }
}
@keyframes polygons {
  25% {
    -webkit-clip-path: polygon(25% 6%, 98% 0, 100% 100%, 0 100%, 3% 1%);
    clip-path: polygon(25% 6%, 98% 0, 100% 100%, 0 100%, 3% 1%);
  }
  50% {
    -webkit-clip-path: polygon(51% 18%, 90% 0, 100% 100%, 0 100%, 9% 3%);
    clip-path: polygon(51% 18%, 90% 0, 100% 100%, 0 100%, 9% 3%);
  }
  75% {
    -webkit-clip-path: polygon(74% 18%, 94% 0, 100% 100%, 0 100%, 3% 2%);
    clip-path: polygon(74% 18%, 94% 0, 100% 100%, 0 100%, 3% 2%);
  }
  95% {
    -webkit-clip-path: polygon(96% 0, 100% 0, 100% 100%, 0 100%, 0 0);
    clip-path: polygon(96% 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
</style>
